<template>

  <div class="bankruptcy">
    <el-form :model="form" ref="form" label-width="110px" class="demo-form">
      <el-row>
        <el-col :span="18">
          <el-form-item label="破产企业名称">
            <el-input v-model="form.name" style="width: 100%"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="状态">
            <el-select
              v-model="form.status"
              placeholder="请选择"
              class="select"
              clearable
              filterable
            >
              <el-option
                v-for="item in States"
                :key="item.nikename"
                :label="item.label"
                :value="item.nikename"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="代理律师(主)">
            <el-select
              v-model="form.leadLawyer"
              placeholder="请选择"
              class="select"
              clearable
              filterable
            >
              <el-option
                v-for="item in Lawyer"
                :key="item.id"
                :label="item.nikename"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6"> </el-col>

        <el-col :span="6">
          <el-form-item label="破产项目来源">
            <el-select
              style="width: 100%"
              v-model="form.soure"
              placeholder="请选择"
              class="select"
              clearable
              filterable
            >
              <el-option
                v-for="item in SoureOptions"
                :key="item.nikename"
                :label="item.nikename"
                :value="item.nikename"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item class="cder" label="开始时间">
            <el-date-picker
              class="select"
              v-model="form.starttime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="起始"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item class="cder" label="结束时间">
            <el-date-picker
              clearable
              class="select"
              v-model="form.endtime"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="终止"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item>
        <div style="text-align: center">
          <el-button type="primary" @click="inputCase()">搜索</el-button>

          <el-button type="danger" @click="clickReset()">重置</el-button>
        </div>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      :header-cell-style="{ textAlign: 'center' }"
      :cell-style="{ textAlign: 'center' }"
      style="width: 100%"
    >
      <el-table-column prop="name" label="破产企业名称"></el-table-column>
      <el-table-column prop="code" label="编号" width="180"></el-table-column>
      <el-table-column prop="soure" label="破产项目来源" width="180">
      </el-table-column>
      <el-table-column prop="cb_lvshi" label="代理律师" width="180">
      </el-table-column>
      <el-table-column prop="sh_lvshi" label="审核人/风控委" width="180">
        <template slot-scope="scope">
          {{ arrobjectToString(scope.row.sh_lvshi) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="collectiondate"
        label="收案时间"
        width="150"
        :formatter="formatTime"
      >
        <template slot-scope="scope">
          {{ formatTime(scope.row.collectiondate) }}
        </template></el-table-column
      >
      <el-table-column
        prop="createdate"
        label="提交时间"
        width="150"
        :formatter="formatTime"
        ><template slot-scope="scope">
          {{ formatTime(scope.row.createdate) }}
        </template></el-table-column
      >
      <el-table-column label="状态" width="100" prop="status">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" type="text" class="casestatus"
            >正常(已通过)</span
          >
          <span v-if="scope.row.status == 1" type="text" class="casesresult"
            >待审核</span
          >
          <span v-if="scope.row.status == 2" type="text" class="casesrefuse"
            >未通过</span
          >
          <span v-if="scope.row.status == -1" type="text" class="casesrefuse"
            >已删除</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="220">
        <template slot-scope="scope">
          <el-button
            type="success"
            plain
            size="small"
            @click="selectCase(scope.row.id)"
            >查看</el-button
          >
          <el-button
            type="primary"
            plain
            size="small"
            @click="printCase(scope.row.id)"
            v-if="
              scope.row.status == 0 &&
              $store.state.rolesname.includes('bankruptcy_print')
            "
            >打印</el-button
          >
          <el-popconfirm
            style="margin: 0 5% 0 5%"
            title="是否确定删除该条数据？"
            @confirm="jqsClick(scope.row.id)"
            v-if="
              scope.row.status == 0 &&
              scope.row.status != -1 &&
              $store.state.rolesname.includes('bankruptcy_delete')
            "
          >
            <el-button type="warning" plain size="small" slot="reference"
              >删除</el-button
            >
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[1, 5, 10, 15, 20]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <!-- 查看/更新 -->
    <el-dialog
      title="详情"
      :visible.sync="detailsDialog"
      width="80%"
      style="text-align: center"
      :close-on-click-modal="false"
      @closed="handleClose"
    >
      <el-row>
        <el-col :span="16">
          <el-form
            :model="dialogForm"
            :rules="rules"
            ref="dialogForm"
            label-width="170px"
            class="demo-form"
          >
            <el-form-item label="破产企业名称" prop="name">
              <el-input :disabled="dlb" v-model="dialogForm.name"></el-input>
            </el-form-item>
            <el-form-item label="身份证号/社会信用代码" prop="idnumber">
              <el-input
                :disabled="dlb"
                v-model="dialogForm.idnumber"
              ></el-input>
            </el-form-item>
            <el-form-item label="编号">
              <el-input disabled v-model="dialogForm.code"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="代理律师(主)" prop="leadLawyer">
                  <el-select
                    style="width: 100%"
                    v-model="dialogForm.leadLawyer"
                    placeholder="请选择"
                    class="select"
                    clearable
                    filterable
                    @change="LeadLawyerChange(dialogForm.leadLawyer)"
                    :disabled="dlb"
                  >
                    <el-option
                      v-for="item in Lawyer"
                      :key="item.id"
                      :label="item.nikename"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代理律师(副)" prop="coCounsel">
                  <el-select
                    style="width: 100%"
                    v-model="dialogForm.coCounsel"
                    placeholder="请选择"
                    class="select"
                    clearable
                    multiple
                    filterable
                    :disabled="dlb"
                  >
                    <el-option
                      v-for="item in Lawyer"
                      :key="item.id"
                      :label="item.nikename"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="破产项目来源" prop="soure">
                  <el-select
                    style="width: 100%"
                    v-model="dialogForm.soure"
                    placeholder="请选择"
                    class="select"
                    clearable
                    filterable
                    :disabled="dlb"
                  >
                    <el-option
                      v-for="item in SoureOptions"
                      :key="item.nikename"
                      :label="item.label"
                      :value="item.nikename"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收案日期" prop="approvaldate">
                  <div
                    class="date_box"
                    @mouseover="onMouseOver()"
                    @mouseleave="onMouseleave()"
                  >
                    <el-date-picker
                      style="width: 100%"
                      v-model="dialogForm.approvaldate"
                      value-format="yyyy-MM-dd"
                      type="date"
                      placeholder="请选择"
                      clearable
                      :disabled="dlb"
                    >
                    </el-date-picker>
                    <i class="el-icon-date" ref="iconDate"></i>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item
                  label="部门审批人"
                  prop="caseLeaders"
                  key="caseLeaders"
                >
                  <el-select
                    style="width: 100%"
                    v-model="dialogForm.caseLeaders"
                    placeholder="请选择"
                    class="select"
                    filterable
                    clearable
                    :disabled="dlb"
                  >
                    <el-option
                      v-for="item in CaseLeaders"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="二次审批人" prop="level">
                  <el-select
                    style="width: 100%"
                    v-model="dialogForm.level"
                    placeholder="请选择"
                    class="select"
                    clearable
                    filterable
                    :disabled="dlb"
                  >
                    <el-option
                      v-for="item in Level"
                      :key="item.id"
                      :label="item.nikename"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="用章类型" prop="sealtype">
              <el-select
                style="width: 100%"
                v-model="dialogForm.sealtype"
                placeholder="请选择"
                class="select"
                clearable
                filterable
                :disabled="dlb"
              >
                <el-option
                  v-for="item in Seal"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <div style="text-align: center">
                <el-button
                  type="primary"
                  :disabled="edit"
                  v-if="
                    !dlb && $store.state.rolesname.includes('bankruptcy_submit')
                  "
                  @click="resubmit('dialogForm')"
                  >重新提交</el-button
                >
                <el-button type="warning" @click="detailsDialog = false"
                  >关闭</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="8">
          <div class="right">
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(item, index) in logs"
                :key="index"
                color="#3077E6"
                :timestamp="item.reason"
              >
                <div style="display: flex; justify-content: space-between">
                  <div>{{ item.content }}</div>

                  <!-- <div class="time">
                      {{ formatTime(item.timestamp, 1) }}
                    </div> -->
                  <div class="time">
                    {{ formatTime(item.timestamp) }}
                  </div>
                </div>
                <div style="color: #909399">{{ item.type }}</div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="right" v-if="processlogs.length > 0">
            <div style="margin-bottom: 10px; font-weight: 600">已审核流程</div>
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(item, index) in processlogs"
                :key="index"
                color="#3077E6"
                :timestamp="item.reason"
              >
                <div style="display: flex; justify-content: space-between">
                  <div>{{ item.type }}</div>

                  <div class="time">
                    {{ item.timestamp }}
                  </div>
                </div>
                <div style="color: #909399">{{ item.name }} {{ item.con }}</div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="right" v-if="Process.length > 0">
            <div style="margin-bottom: 10px; font-weight: 600">未审核</div>
            <el-timeline :reverse="false">
              <el-timeline-item
                v-for="(item, index) in Process"
                :key="index"
                :timestamp="item.type"
              >
                {{ item.name }}
              </el-timeline-item>
            </el-timeline>
          </div>
        </el-col>
      </el-row>
      <!-- 冲突案件 -->
      <div class="conflict">
        <div class="top">
          <div class="icon"></div>
          <div>
            案件冲突<span
              style="color: black; font-size: 14px; margin-left: 10px"
              >(<span style="color: blue">蓝色</span>为代理方,
              <span style="color: red; font-weight: 900">!</span
              >橙色代表冲突方，灰色背景是导入数据)</span
            >
          </div>
        </div>
        <el-table
          :data="caseConflictData"
          style="width: 95%; margin-left: 2%"
          :header-cell-style="{ textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          :row-class-name="tableRowClass"
        >
          <el-table-column prop="code" label="案件编号" width="150">
          </el-table-column>
          <el-table-column prop="title" label="案件名称" width="300">
          </el-table-column>
          <el-table-column prop="litigant" label="当事人">
            <template slot-scope="scope">
              <div
                v-for="(c, index) in scope.row.litigant"
                class="litigant-container"
              >
                {{ c.attribute }}：
                <span
                  v-for="(item, index) in c.all"
                  :key="item.id"
                  style="display: inline"
                >
                  <span v-if="item.isshow" style="color: red; font-weight: 900"
                    >!</span
                  >
                  <span
                    :style="{
                      color: getRandomColor(item.isClient, item.isshow),
                    }"
                    >{{ item.name }}</span
                  >
                  <span v-if="index < c.all.length - 1">, </span>
                </span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="冲突对象">
            <template slot-scope="scope">
              {{ GetNameIdnumber(scope.row.litigant) }}
            </template>
          </el-table-column>
          <el-table-column prop="entrustmentTime" label="委托时间" width="150">
            <template slot-scope="scope">
              {{ formatTime(scope.row.entrustmentTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" fixed="right">
            <template slot-scope="scope">
              <el-button
                class="copy"
                @click="conflictClick(scope.row)"
                v-if="!scope.row.isOther"
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div v-if="hasMore" style="text-align: center">
          <el-button type="text" @click="showAllCaseClick">
            {{ showAllCase ? "收起" : `查看更多` }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 选择律所与代理律师 -->
    <el-dialog
      title="选择律所与代理律师"
      center
      :visible.sync="lsDialog"
      width="40%"
      @close="lsClose()"
    >
      <div class="lsdialog">
        <div style="font: 1.8em sans-serif">选择律所&nbsp;</div>
        <el-select
          clearable
          v-model="ls"
          placeholder="请选择"
          @change="lvChange()"
        >
          <el-option
            v-for="item in lvSuo"
            :key="item.value"
            :label="item.label"
            :value="item.label"
          >
          </el-option>
        </el-select>
      </div>
      <div class="lsdialog">
        <div style="font: 1.8em sans-serif">选择律师&nbsp;</div>
        <el-select clearable v-model="lv" placeholder="请选择" multiple>
          <el-option
            v-for="item in lvShi"
            :key="item.sid"
            :label="item.sname"
            :value="item.sname"
          >
          </el-option>
        </el-select>
      </div>
      <div class="printenter">
        <el-button type="primary" @click="printEnter()">确定</el-button>
      </div>
    </el-dialog>

    <!-- 代理人选择 -->
    <el-dialog
      title="请选择代理人"
      :visible.sync="clientDialog"
      width="30%"
      center
    >
      <div style="text-align: center">
        <el-select
          v-model="clientOption"
          class="all-select"
          clearable
          placeholder="请选择"
          multiple
        >
          <el-option
            v-for="item in clientOptions"
            :key="item.pvalue"
            :label="item.pcname"
            :value="item.pvalue"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clientDialog = false">取 消</el-button>
        <el-button type="primary" @click="clientPrint(clientOption)"
          >确 认</el-button
        >
      </span>
    </el-dialog>

    <!-- 在线打印 -->
    <!-- <div v-show="false" class="dayin"> -->
    <div class="dayin" id="dayin" ref="postHtml">
      <div id="casetable">
        <!-- 案件审批单 -->
        <div v-if="qrcode == '案件审批单'">
          <div class="case_title center_font" style="line-height: 30px">
            <span class="CheckTitle">{{ printInfo.printTitle }}</span>
          </div>
          <div
            class="case_title center_font"
            style="line-height: 30px; margin-bottom: 15px"
          >
            案件审批单
          </div>

          <div class="case_main">
            <table class="case_tb" border="1" cellspacing="0" cellpadding="0">
              <tr>
                <td class="td_l" colspan="3">案件名称</td>
                <td class="td_r" colspan="7" style="text-align: center">
                  {{ printInfo.title }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">案件编号</td>
                <td class="td_r" colspan="7" style="text-align: center">
                  {{ printInfo.caseCode }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">案件类型</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.caseType }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">案件用章类型</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.sealType }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">代理律师</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.lawyerNames }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">提交时间</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.postDate }}
                </td>
              </tr>
              <tr>
                <td class="td_l" colspan="3">审批情况</td>
                <td class="td_r Lawyer_Names" colspan="7">
                  {{ printInfo.shr }}
                </td>
              </tr>

              <tr>
                <td class="td_l" colspan="3">部门盖章</td>
                <td class="td_r Lawyer_Names" colspan="7"></td>
              </tr>
            </table>
          </div>
          <div class="case_row"></div>
        </div>

        <p style="position: absolute; bottom: 0">{{ printInfo.address }}</p>
        <!-- 二维码 -->
        <div
          v-if="qrcode != null && qrcode != ''"
          id="ercode"
          data-html2canvas-ignore="true"
        >
          <!-- <img :src="img" /> -->
        </div>
      </div>
    </div>

    <!-- 冲突预览 -->
    <el-dialog
      center
      title="预览"
      :visible.sync="isChong"
      append-to-body
      class="file-dialog"
      width="85%"
      @close="closChong"
    >
      <el-form class="form" ref="formrefCT" :model="CTform" label-width="200px">
        <!-- 案件当事人 -->
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6 ||
            chongCaseType == 9
          "
          style="width: 90%"
        >
          <div class="divider"></div>
          <div class="top">
            <div class="icon"></div>
            <div>案件当事人</div>
          </div>
          <el-row>
            <el-table
              class="party"
              border
              :data="CTform.tableData"
              style="width: calc(100% - 61px)"
              :header-cell-style="{ textAlign: 'center' }"
              :cell-style="{ textAlign: 'center' }"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                label="属性"
                prop="attribute"
                :render-header="addRedStar"
                width="160"
              >
                <!-- <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.attribute"
                    clearable
                    filterable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in ArrtibuteOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template> -->
              </el-table-column>
              <el-table-column
                label="类型"
                prop="isUnit"
                :render-header="addRedStar"
                width="100"
              >
                <template slot-scope="scope">
                  <el-select
                    size="mini"
                    v-model="scope.row.isUnit"
                    clearable
                    disabled
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in typeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                label="姓名/单位名称"
                prop="name"
                :render-header="addRedStar"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="身份证号/社会信用代码"
                prop="name"
                :show-overflow-tooltip="true"
                min-width="360"
              >
              </el-table-column>
              <el-table-column
                label="委托方"
                prop="isClient"
                :render-header="addRedStar"
                width="80"
              >
                <template slot-scope="scope">
                  <el-checkbox
                    :disabled="bianji"
                    v-model="scope.row.isClient"
                    @change="clientChange(scope.row)"
                  ></el-checkbox>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </div>

        <div class="text">
          <div style="width: 90%">案件信息：{{ CTform.title }}</div>
        </div>
        <div
          v-if="
            chongCaseType == 1 ||
            chongCaseType == 2 ||
            chongCaseType == 3 ||
            chongCaseType == 4 ||
            chongCaseType == 5 ||
            chongCaseType == 6
          "
          style="width: 90%"
        >
          <el-row>
            <el-col :span="24">
              <el-form-item label="案件名称" prop="title">
                <el-input
                  v-model="CTform.title"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" v-if="chongCaseType == 3">
              <el-form-item label="公益诉讼" prop="public_welfare">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.public_welfare"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构案号" prop="acceptcode">
                <el-input
                  v-model="CTform.acceptcode"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="chongCaseType != 4">
              <el-form-item label="法律援助" prop="assist">
                <el-select
                  v-model="CTform.assist"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Flyz"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案卷状态" prop="ajstatus">
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  style="width: 100%"
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    style="width: 100%"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="10">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 10px; margin-top: 4px"
                v-if="CTform.casestatus == '未受理' && bianji && form.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" class="date_box">
              <el-form-item label="收案日期" prop="approvaldate">
                <div
                  class="date_box"
                  @mouseover="onMouseOver()"
                  @mouseleave="onMouseleave()"
                >
                  <el-date-picker
                    style="width: 100%"
                    v-model="CTform.approvaldate"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="系统自动生成"
                    clearable
                    disabled
                  >
                  </el-date-picker>
                  <!-- <i class="el-icon-date" ref="iconDate"></i> -->
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案件来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="受理机构" prop="acceptUnit">
                <el-input
                  v-model="CTform.acceptUnit"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="案由" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  clearable
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="leadLawyer">
                <el-select
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-if="false">
              <el-form-item
                label="委托事项"
                prop="remark"
                v-if="chongCaseType != 2"
              >
                <el-select
                  style="width: 100%"
                  v-model="CTform.remark"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Entrust"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="chongCaseType == 2"
                label="介入阶段"
                prop="intervene"
              >
                <el-select
                  filterable
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.intervene"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in Intervene"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="chongCaseType == 2">
            <el-col :span="12" v-if="CTform.result == 1">
              <el-form-item label="刑事风险控制人" prop="criminalrisk">
                <el-select
                  style="width: 100%"
                  v-model="CTform.criminalrisk"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Criminal"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12"> </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="12"
              v-if="
                chongCaseType != 7 &&
                chongCaseType != 8 &&
                chongCaseType != 14 &&
                chongCaseType != 9 &&
                CTform.result == 1
              "
            >
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  placeholder="请选择"
                  class="select"
                  clearable
                  disabled
                  multiple
                  :multiple-limit="1"
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                placeholder="请选择"
                clearable
                v-model="CTform.caseLeaderscase"
                @change="bmzgChange"
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
        </div>

        <div v-else style="width: 90%">
          <el-row>
            <el-col :span="24">
              <el-form-item label="项目名称" prop="title">
                <el-input v-model="CTform.title" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item label="受理机构案号" prop="acceptcode">
              <el-input
                v-model="CTform.acceptcode"
                placeholder="请输入"
                clearable
                :disabled="bianji"
              ></el-input>
            </el-form-item>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="项目概要" prop="cause">
                <el-input
                  v-model="CTform.cause"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="案件编号" prop="code">
                <el-input
                  v-model="CTform.code"
                  placeholder="自动编号"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                label="案卷状态"
                prop="ajstatus"
                v-if="chongCaseType != 12 && chongCaseType != 13"
              >
                <el-select
                  v-model="CTform.ajstatus"
                  placeholder="请选择"
                  class="input"
                  style="width: 100%"
                  disabled
                  @change="inputType(form.ajstatus, null)"
                >
                  <el-option
                    v-for="item in Ajstatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="破产案件类型"
                prop="bcz.projecttype"
                v-if="chongCaseType == 12"
              >
                <el-select
                  style="width: 100%"
                  v-model="CTform.bcz.projecttype"
                  placeholder="请选择"
                  class="select"
                  disabled
                >
                  <el-option
                    v-for="item in ProjectType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="false">
            <el-col :span="12">
              <el-form-item label="受理状态" prop="casestatus">
                <el-select
                  disabled
                  v-model="CTform.casestatus"
                  placeholder="请选择"
                  class="select"
                  clearable
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in CaseStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button
                size="small"
                @click="Accept()"
                style="margin-left: 20px"
                v-if="CTform.casestatus == '未受理' && bianji && CTform.uid"
                type="primary"
                plain
                >点此受理</el-button
              >
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item label="项目合伙人" prop="partner">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.partner"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="底稿资料" prop="draft">
                <el-select
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.draft"
                  placeholder="请选择"
                  class="select"
                  disabled
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in Draft"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 一般非诉项目、单独出具律师意见审批书、单独出具律师函没有二次审批人 -->
          <el-row
            v-if="
              chongCaseType != 7 &&
              chongCaseType != 8 &&
              chongCaseType != 14 &&
              chongCaseType != 9 &&
              (form.result == 1 || bianji == false)
            "
            style="width: 90%"
          >
            <el-col :span="14">
              <el-form-item label="二次审批人" prop="level">
                <el-select
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  disabled
                  @change="bmzgChange"
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="divider"></div>
          <el-row>
            <el-col :span="14" class="date_box">
              <el-form-item label="立项日期" prop="approvaldate">
                <el-date-picker
                  style="width: 100%"
                  v-model="CTform.approvaldate"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="系统自动生成"
                  disabled
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="项目来源" prop="source">
                <el-input
                  v-model="CTform.source"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '代理机构' : '受理机构'"
                prop="acceptUnit"
                v-if="chongCaseType == 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
              <el-form-item
                :label="chongCaseType == 12 ? '管辖法院' : '受理机构'"
                v-if="chongCaseType != 10"
              >
                <el-input v-model="CTform.acceptUnit" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="10"
              v-if="
                chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9 ||
                chongCaseType == 11
              "
            >
              <el-form-item label="项目分类" prop="classification">
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.classification"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 10">
              <el-form-item label="项目类型" prop="projecttype">
                <el-select
                  v-if="CTform.bcz != null"
                  style="width: 100%"
                  v-model="CTform.bcz.projecttype"
                  disabled
                >
                  <el-option
                    v-for="item in Projecttype"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="chongCaseType == 12">
              <el-form-item label="案件级别">
                <el-select
                  style="width: 100%"
                  v-model="CTform.bcz.caselevel"
                  placeholder="请选择"
                  class="select"
                  disabled
                >
                  <el-option
                    v-for="item in Level"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14">
              <el-form-item
                :label="chongCaseType == 10 ? '服务律师' : '代理律师'"
                prop="leadLawyer"
              >
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.leadLawyer"
                  class="select"
                  multiple
                  :multiple-limit="1"
                  @change="LeadLawyerChange(CTform.leadLawyer)"
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item label="代理律师" prop="coCounsel">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.coCounsel"
                  placeholder="请选择"
                  class="select"
                  clearable
                  multiple
                  disabled
                >
                  <el-option
                    v-for="item in Lawyer"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                    disabled
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-if="
              (chongCaseType == 7 ||
                chongCaseType == 8 ||
                chongCaseType == 14 ||
                chongCaseType == 9) &&
              CTform.result == 1
            "
          >
            <el-col :span="14">
              <el-form-item label="风控委" prop="level">
                <el-select
                  filterable
                  style="width: 100%"
                  v-model="CTform.level"
                  class="select"
                  multiple
                  :multiple-limit="2"
                  disabled
                >
                  <el-option
                    v-for="item in FKW"
                    :key="item.id"
                    :label="item.nikename"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="CTform.result == 1">
            <el-form-item label="部门主管" prop="caseLeaderscase">
              <el-select
                filterable
                style="width: 100%"
                v-model="CTform.caseLeaderscase"
                placeholder="请选择"
                class="select"
                clearable
                @change="bmzgChange"
              >
                <el-option
                  v-for="item in CaseLeaders"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <!-- 与其他法律服务有关的招投标项目栏独有字段 -->
          <div v-if="chongCaseType == 10">
            <el-row>
              <el-col :span="14">
                <el-form-item label="开放时间" prop="opentime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.opentime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购方式" prop="procuremethod">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procuremethod"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="14">
                <el-form-item label="预算金额" prop="budgetmoney">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.budgetmoney"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="采购编号" prop="procurecode">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.procurecode"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 专项服务合同独有字段 -->
          <div v-if="chongCaseType == 11">
            <el-row>
              <el-col :span="14">
                <el-form-item label="合同服务类型" prop="contracttype">
                  <el-input
                    v-if="CTform.bcz != null"
                    v-model="CTform.bcz.contracttype"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="服务期限" prop="servicetime">
                  <el-date-picker
                    v-if="CTform.bcz != null"
                    style="width: 100%"
                    v-model="CTform.bcz.servicetime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    disabled
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div v-if="chongCaseType == 12">
            <el-row>
              <el-col :span="14">
                <el-form-item label="项目负责人">
                  <el-input
                    v-model="CTform.bcz.porjectleader"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="委托人摇号">
                  <el-input
                    v-model="CTform.bcz.lottery"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-form-item label="管理人账号">
                  <el-select
                    style="width: 100%"
                    v-model="CTform.bcz.administrator"
                    placeholder="请选择"
                    class="select"
                    disabled
                  >
                    <el-option
                      v-for="item in Administrator"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!CTform.bcz.administrator">
              <el-col :span="14">
                <el-form-item label="开户账号">
                  <el-input
                    v-model="CTform.bcz.account"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item label="开户银行">
                  <el-input
                    v-model="CTform.bcz.bank"
                    placeholder="请输入"
                    disabled
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="divider"></div>

          <el-row v-if="chongCaseType != 9">
            <el-col :span="14">
              <el-form-item
                v-if="chongCaseType != 12"
                :label="chongCaseType == 10 ? '采购单位' : '客户名称'"
                prop="bcz.procureunit"
              >
                <el-input
                  v-if="CTform.bcz != null"
                  v-model="CTform.bcz.procureunit"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
              <el-form-item
                label="债务人名称"
                prop="bcz.debtorName"
                v-if="chongCaseType == 12"
              >
                <el-input
                  v-model="CTform.bcz.debtorName"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item
                label="身份证号/社会信用代码"
                prop="bcz.idnumber"
                v-if="chongCaseType != 10"
              >
                <el-input
                  v-model="CTform.bcz.idnumber"
                  placeholder="请输入"
                  disabled
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>

    <!-- 重新提交 案件冲突 -->
    <el-dialog
      title="冲突"
      :visible.sync="caseConflict"
      width="80%"
      style="text-align: center"
      @close="chanle"
    >
      <el-form
        ref="formConflict"
        :model="formConflict"
        label-width="150px"
        :rules="rulesConflict"
      >
        <el-row v-if="conflictShow">
          <el-col :span="8">
            <el-form-item label="二次利冲审批人" prop="conflictApproval">
              <el-select
                v-model="formConflict.conflictApproval"
                clearable
                placeholder="请选择二次利冲审批人"
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in OptiomConflict"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div
        v-if="OptiomConflict.length < 1 && allConflictCount > 0"
        style="color: red; font-size: 18px; margin-bottom: 12px"
      >
        暂无二次利冲审批人，无法录入
      </div>

      <h2>
        案件冲突<span style="color: black; font-size: 14px; margin-left: 10px"
          >(<span style="color: blue">蓝色</span>为代理方,
          <span style="color: red; font-weight: 900">!</span
          >橙色代表冲突方，灰色背景是导入数据)</span
        >
      </h2>
      <el-table
        :data="conflictList"
        style="width: 100%; height: 200"
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :row-class-name="tableRowClass"
        max-height="380px"
      >
        <el-table-column prop="code" label="案件编号" width="100">
        </el-table-column>
        <el-table-column prop="title" label="案件名称" width="240">
        </el-table-column>
        <el-table-column prop="litigant" label="当事人" min-width="300">
          <template slot-scope="scope">
            <div
              v-for="(c, index) in scope.row.litigant"
              class="litigant-container"
            >
              {{ c.attribute }}：
              <span
                v-for="(item, index) in c.all"
                :key="item.id"
                style="display: inline"
              >
                <span v-if="item.isshow" style="color: red; font-weight: 900"
                  >!</span
                >
                <span
                  :style="{
                    color: getRandomColor(item.isClient, item.isshow),
                  }"
                  >{{ item.name }}</span
                >
                <span v-if="index < c.all.length - 1">, </span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="冲突对象">
          <template slot-scope="scope">
            {{ GetNameIdnumber(scope.row.litigant) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="entrustmentTime" label="委托时间" width="150">
          <template slot-scope="scope">
            {{ formatTime(scope.row.entrustmentTime) }}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="scope">
            <el-button
              @click="conflictClick(scope.row)"
              v-if="!scope.row.isOther"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div v-if="dialoghasMore" style="text-align: center">
        <el-button type="text" @click="dialogshowAllCaseClick">
          {{ dialogshowAllCase ? "收起" : `查看更多` }}
        </el-button>
      </div>

      <div class="conflic_btn">
        <el-button
          @click="conflict('formConflict')"
          type="primary" :disabled="dianji"
          v-if="!(allConflictCount > 0 && OptiomConflict.length <= 0)"
          >继续录入</el-button
        >
        <el-button type="warning" @click="chanle()">取消录入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  caseLawyerApi,
  bkSelect,
  oldSelect,
  caseLog,
  bkUpdate,
  bkDelete,
  printInfo,
  printLvSuoApi,
  unProcess,
  logProcess,
  BKCaseConflict,
  allCaseApi,
  ConflictMember,
} from "../../api/case";
import printJS from "print-js";
import QRCode from "qrcodejs2";
import html2canvas from "html2canvas";

import axios from "axios";
import { CaseProcess, CaseApprover } from "../../api/bankrupt";
import { GetDepartmentLeaders } from "../../api/bankrupt";
import { user } from "../../api/seal";
export default {
  name: "bankruptcyManagerInfo",
  data() {
    var ajstatusCheck = (rule, value, callback) => {
      if (value == null || value === undefined || value == "" || value == []) {
        callback(new Error("请输入或选择！"));
      }
      callback();
    };
    return {
      form: {
        name: null,
        leadLawyer: null,
        soure: null,
        starttime: null,
        endtime: null,
        status: null,
      },
      dialogForm: {
        id: null,
        name: null,
        leadLawyer: null,
        coCounsel: null,
        soure: null,
        approvaldate: null,
        caseLeaders: null,
        level: null,
        sealtype: null,
        status: null,
        code: null,
        idnumber: null,
        sealtype: null,
      },
      rules: {
        name: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ["blur", "change"],
          },
        ],
        leadLawyer: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ["blur", "change"],
          },
        ],
        soure: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ["blur", "change"],
          },
        ],
        approvaldate: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ["blur", "change"],
          },
        ],
        caseLeaders: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ["blur", "change"],
          },
        ],
        level: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ["blur", "change"],
          },
        ],
        sealtype: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ["blur", "change"],
          },
        ],
        idnumber: [
          {
            required: true,
            validator: ajstatusCheck,
            trigger: ["blur", "change"],
          },
        ],
      },
      PrintOptions: ["案件审批单", "单独出具律师函审批单", "法律意见书审批单"],
      SoureOptions: [
        { label: "投标", nikename: "投标" },
        { label: "指定", nikename: "指定" },
      ],
      States: [
        { label: "正常(审核通过)", nikename: 0},
        { label: "审核中", nikename: 1 },
        { label: "审核未通过", nikename: 2 },
        { label: "删除", nikename: -1 },
      ],
      // 代理律师
      Lawyer: [],
      // 部门审批人
      CaseLeaders: [],
      // 二次审批人
      Level: [],
      // 用章类型
      Seal: [
        { value: "contract_seal", label: "合同章" },
        { value: "corporate_seal", label: "法人章" },
        { value: "official_seal", label: "公章" },
        { label: "公章+法人章", value: "official_corporate_seal" },
        { label: "合同章+法人章", value: "contract_corporate_seal" },
      ],
      printInfo: {
        printTitle: null,
        yuanGao: null,
        beiGao: null,
        diSanren: null,
        ysBeigao: null,
        client: null,
        cause: null,
        fileName: null,
        postDate: null,
        lawyerNames: null,
        checkDate: null,
        title: null,
        charge: null,
        acceptUnit: null,
        caseCode: null,
        cause: null,
        caseType: null,
        sealType: null,
        address: null,
        printTitle: null,
      },
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 回显
      tableData: [],
      detailsDialog: false,
      dlb: false,
      logs: [],
      Process: {}, //未审核
      processlogs: {},

      //打印数据
      bid: null,
      lsDialog: false, // 选择律所
      lvSuo: [], // 返回的律所
      lvShi: [], // 返回的代理律师
      ls: null, // 选的律所
      lv: null, // 选的律师
      qrcode: null,
      printData: {
        printable: "casetable",
        // header:'再生资源收货单',
        ignore: ["no-print"],
        type: "html", // 打印的元素类型
      },

      bl: true,
      cts: 3,
      lawFile: "",
      clientDialog: false,
      clientOptions: [],
      clientOption: null,
      centerDialogVisible: false,
      loading: true,

      newtype: [],

      caseConflictData: [], //冲突案件
      showAllCase: false, //是否显示全部冲突案件
      hasMore: false,
      allConflictCase: [], //所有的冲突案件

      chongCaseType: "",
      isChong: false, //案件冲突详情弹出框
      CTform: {
        bcz: {
          idnumber: null,
        },
      },
      // 法律援助
      Flyz: [
        { label: "是", value: true },
        { label: "否", value: false },
      ],
      // 项目类型
      Projecttype: [
        { label: "政府采购", value: 0 },
        { label: "国企采购", value: 1 },
        { label: "其他社会采购", value: 2 },
      ],
      // 单位/个人
      typeOptions: [
        { value: true, label: "个人" },
        { value: false, label: "单位" },
      ],
      ProjectType: [
        { label: "重整案件", value: "重整案件" },
        { label: "预重整", value: "预重整" },
        { label: "公益案件", value: "公益案件" },
      ],
      bianji: true,
      Draft: [
        { label: "已归档", value: true },
        { label: "未归档", value: false },
      ], //底稿资料
      // 案卷状态
      Ajstatus: [
        { label: "一审", value: "一审" },
        { label: "二审", value: "二审" },
        { label: "再审", value: "再审" },
        { label: "破产申报", value: "破产申报" },
        { label: "再审听证", value: "再审听证" },
        { label: "行政复议", value: "行政复议" },
        { label: "首次执行", value: "首次执行" },
        { label: "恢复执行", value: "恢复执行" },
        { label: "执行异议", value: "执行异议" },
        { label: "仲裁阶段", value: "仲裁阶段" },
        { label: "侦查阶段", value: "侦查阶段" },
        { label: "审查起诉", value: "审查起诉" },
        { label: "无", value: "无" },
        // { label: '受理', value: '受理' },
        // { label: '未受理', value: '未受理' }
      ],
      // 公益诉求
      options: [
        { value: 0, label: "是" },
        { value: 1, label: "否" },
      ],
      //二次利冲审批人
      conflictShow: false, //是否显示选择框，若无利冲或只有一个审批人的情况下不显示
      allConflictCount: 0, //总冲突数量
      OptiomConflict: [], //所有二次利冲审批人
      formConflict: {
        conflictApproval: null,
      },
      rulesConflict: {
        conflictApproval: [
          { required: true, message: "不能为空", trigger: "blur" },
        ],
      },
      dialogshowAllCase: false, //是否显示全部冲突案件
      dialoghasMore: false,
      dialogallConflictCase: [], //所有的冲突案件
      caseConflict: false, //重新提交是案件冲突弹出框
      conflictList: {},

      edit:false,//提交按钮
      dianji:false,//继续录入按钮

       
    };
  },

  methods: {
    // 重新提交
    resubmit(formref) {
      this.edit=true
      this.$refs[formref].validate((valid) => {
        if (valid) {
          this.EnterCaseConflictSelect();
          // bkUpdate({
          //   id: this.dialogForm.id,
          //   name: this.dialogForm.name,
          //   leadLawyer: this.dialogForm.leadLawyer,
          //   coCounsel: this.dialogForm.coCounsel,
          //   soure: this.dialogForm.soure,
          //   approvaldate: this.dialogForm.approvaldate,
          //   caseLeaders: this.dialogForm.caseLeaders,
          //   level: this.dialogForm.level,
          //   sealtype: this.dialogForm.sealtype,
          //   idnumber: this.dialogForm.idnumber,
          // })
          //   .then((res) => {
          //     if (res.data.status == 0) {
          //       this.$message.success(res.data.message);
          //     } else {
          //       this.$message.error(res.data.message);
          //     }
          //     this.$refs[formref].resetFields();
          //     this.inputCase();
          //   })
          //   .catch(() => {
          //     this.$message.error("前台错误！");
          //   });
        } else {
          this.edit=false
          this.$nextTick(() => {
            const errorField = this.$el.querySelector(".el-form-item.is-error");
            if (errorField) {
              errorField.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          });
          this.$message.error("请检查案件信息填写错误!");
        }
      });
      // this.detailsDialog = false;
    },
    //提交案件的时候案件冲突
    EnterCaseConflictSelect() {
      BKCaseConflict({
        name: this.dialogForm.name,
        idnumber: this.dialogForm.idnumber,
      }).then((res) => {
        if (res.data.status == "success") {
          // 弹出案件冲突
          this.dialogallConflictCase = res.data.data;
          if (this.dialogallConflictCase.length > 0) {
            // this.isLoading = false
            // this.caseConflict=true

            this.allConflictCount = 0;
            this.formConflict.conflictApproval = null;
            this.conflictShow = false;
            if (this.dialogallConflictCase.length > 0) {
              this.conflictList = this.dialogallConflictCase.filter(
                (item) => item.isClient == 1
              );
              this.allConflictCount =
                this.allConflictCount + this.conflictList.length;
              if (this.conflictList.length == 0) {
                this.conflictList.push(this.dialogallConflictCase[0]);
              }
              if (
                this.dialogallConflictCase.length > this.conflictList.length &&
                this.dialogallConflictCase.length > 1
              ) {
                this.dialoghasMore = true;
              }
            }
            // console.log(this.allConflictCount )
            if (this.allConflictCount > 0) {
              this.GetConflictMember();
            } else {
              this.caseConflict = true;
            }
          } else {
            this.addCaseEnter();
          }
        } else if (
          res.data.status == "401" ||
          res.data.status == "402" ||
          res.data.status == "403"
        ) {
          this.$message.error(res.data.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
          return;
        } else {
          this.edit=false
          this.$message.error(res.data.message);
        }
      });
    },
    async GetConflictMember() {
      ConflictMember().then((res) => {
        if (res.data.status == "success") {
          this.OptiomConflict = res.data.data;
          this.caseConflict = true;

          if (this.OptiomConflict.length > 1) {
            this.conflictShow = true;
          } else if (this.OptiomConflict.length == 1) {
            this.conflictShow = false;
            this.formConflict.conflictApproval = this.OptiomConflict[0].value;
          }
          // console.log( this.conflictShow)
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    dialogshowAllCaseClick() {
      if (this.dialogshowAllCase) {
        this.dialogshowAllCase = false;
        this.conflictList = this.dialogallConflictCase.filter(
          (item) => item.isClient == 1
        ); //所有有冲突的案件
        if (this.conflictList.length == 0) {
          //没有冲突案件
          this.conflictList.push(this.dialogallConflictCase[0]);
        }
      } else {
        this.conflictList = this.dialogallConflictCase;
        this.dialogshowAllCase = true;
      }
    },
    //提交
    addCaseEnter() {
      this.edit=true
      this.dianji = true
      bkUpdate({
        id: this.dialogForm.id,
        name: this.dialogForm.name,
        leadLawyer: this.dialogForm.leadLawyer,
        coCounsel: this.dialogForm.coCounsel,
        soure: this.dialogForm.soure,
        approvaldate: this.dialogForm.approvaldate,
        caseLeaders: this.dialogForm.caseLeaders,
        level: this.dialogForm.level,
        sealtype: this.dialogForm.sealtype,
        idnumber: this.dialogForm.idnumber,
        conflictApproval:this.formConflict.conflictApproval==''?null:this.formConflict.conflictApproval,
      })
        .then((res) => {
          if (res.data.status == 0) {
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
          // this.$refs[formref].resetFields();
          this.inputCase();
          this.edit=false
          this.dianji = false
        })
        .catch(() => {
          this.edit=false
          this.dianji = false
          this.$message.error("前台错误！");
        });
         this.detailsDialog = false
    },
    // 继续录入
    conflict(formref) {
      this.dianji = true
      this.$refs[formref].validate((valid) => {
        if (valid) {
          this.caseConflict=false
          this.addCaseEnter();
        } else {
          this.dianji = false
          this.$nextTick(() => {
            const errorField = this.$el.querySelector(".el-form-item.is-error");
            if (errorField) {
              errorField.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
          });
        }
      });
    },
    // 删除
    jqsClick(id) {
      bkDelete({ bkid: id }).then((res) => {
        if ((res.data.status = "0")) {
          this.$message.success("删除成功");
          this.inputCase();
        } else {
          this.$message.error("删除失败");
        }
      });
    },
    // 代理律师/申请人/代理律师
    GetLawyer() {
      caseLawyerApi({}).then((res) => {
        if (res.data.status == "success") {
          this.Lawyer = res.data.data;
        } else if (
          res.data.status == "401" ||
          res.data.status == "402" ||
          res.data.status == "403"
        ) {
          this.$message.error(res.data.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
          return;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 获取案件审核部门主管
    GetDepartmentLeaders(lvshi) {
      if (lvshi == "" || lvshi == null) {
        return;
      }

      GetDepartmentLeaders({
        Id: lvshi,
      }).then((res) => {
        if (res.data.status == "0") {
          this.CaseLeaders = res.data.data;
          var index = this.CaseLeaders.findIndex((item) => {
            return item.value == this.form.caseLeaders;
          });
          // console.log("index:"+index)
          if (index == -1) {
            //不存在，清空
            this.form.caseLeaders = "";
          }
        } else if (
          res.data.status == "401" ||
          res.data.status == "402" ||
          res.data.status == "403"
        ) {
          this.$message.error(res.data.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
          return;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 案件二次审批人/用章二次审批人
    GetLevel(lvshi) {
      if (lvshi == "" || lvshi == null) {
        return;
      }
      user({
        Id: this.form.leadLawyer,
        apporver: "case_00000000-0011-0011-0012-000000000000",
      }).then((res) => {
        if (res.data.status == "success") {
          this.Level = res.data.data;
          var index = this.Level.findIndex((item) => {
            return item.id == this.form.level;
          });
          if (index == -1) {
            //不存在，清空二次审批人
            this.form.level = "";
          }
        } else if (
          res.data.status == "401" ||
          res.data.status == "402" ||
          res.data.status == "403"
        ) {
          this.$message.error(res.data.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
          return;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    // 代理律师 改变
    LeadLawyerChange(lvshi) {
      this.GetDepartmentLeaders(lvshi);
      this.GetLevel(lvshi);
    },

    // 重置
    clickReset() {
      this.form.name = null;
      this.form.leadLawyer = null;
      this.form.soure = null;
      this.form.starttime = null;
      this.form.endtime = null;
      this.form.status = null;
    },

    // 承办律师
    arrToString(arr) {
      return arr.join(" , ");
    },
    // 审核人/风控委
    arrobjectToString(arrobject) {
      var s = "";
      arrobject.forEach((value, index, array) => {
        s += value.nikename;
        if (index < arrobject.length - 1) {
          s = s + "，";
        }
      });
      return s;
    },

    // 分页查询
    handleSizeChange(val) {
      this.pageSize = val;
      this.inputCase();
    },
    // 分页查询
    handleCurrentChange(val) {
      this.currentPage = val;
      this.inputCase();
    },

    // 查询
    inputCase() {
      bkSelect({
        name: this.form.name == "" ? null : this.form.name,
        leadLawyer: this.form.leadLawyer == "" ? null : this.form.leadLawyer,
        soure: this.form.soure == "" ? null : this.form.soure,
        starttime: this.form.starttime == "" ? null : this.form.starttime,
        endtime: this.form.endtime == "" ? null : this.form.endtime,
        status: this.form.status == "" ? null : this.form.status,
        page: this.currentPage,
        rows: this.pageSize,
      })
        .then((res) => {
          if (res.data.status == 0) {
            this.total = parseInt(res.data.message);
            this.tableData = res.data.data;
            // console.log('查询成功', res.data.data)
          }
        })
        .catch((err) => {
          console.log("查询失败", err);
        });
    },

    // 明细查询
    selectCase(id) {
      caseLog({ Id: id }).then((res) => {
        if (res.data.status == "success") {
          this.logs = res.data.data;
        }
      });
      unProcess({ BankId: id }).then((res) => {
        if (res.data.status == "success") {
          this.Process = res.data.data;
        }
      });
      logProcess({ BankId: id }).then((res) => {
        if (res.data.status == "success") {
          this.processlogs = res.data.data;
        }
      });
      oldSelect({ bkid: id })
        .then((res) => {
          if (res.data.data != null) {
            this.dialogForm.id = res.data.data[0].id;
            this.dialogForm.approvaldate = this.formatTime(
              res.data.data[0].collectionDate
            );
            this.dialogForm.coCounsel = res.data.data[0].deputyLawyer;
            this.dialogForm.leadLawyer = res.data.data[0].mainLawyer;
            this.dialogForm.name = res.data.data[0].name;
            this.dialogForm.soure = res.data.data[0].soure;
            this.dialogForm.status = res.data.data[0].status;
            this.dialogForm.caseLeaders = res.data.data[0].sh_lvshi[0].memberId;
            this.dialogForm.level = res.data.data[0].sh_lvshi[1].memberId;
            this.dialogForm.sealtype = res.data.data[0].sealType;
            this.dialogForm.code = res.data.data[0].code;
            this.dialogForm.idnumber = res.data.data[0].idnumber;
            this.detailsDialog = true;
            this.CaseConflictSelect(); //获取冲突案件
            if (res.data.data[0].status != 2) {
              // 不可编辑
              this.dlb = true;
            } else {
              this.dlb = false;
            }
          }
        })
        .catch(() => {});
    },
    // --时间格式转换--
    formatTime(row) {
      const date = new Date(row);
      // return row[column.property].Format('yyyy-MM-dd HH:mm')
      var year = date.getFullYear();
      /* 在日期格式中，月份是从0开始的，因此要加0
       * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
       * */
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      if (hours == "00" && minutes == "00" && seconds == "00") {
        return year + "-" + month + "-" + day;
      } else {
        return (
          year + "-" + month + "-" + day
          // +
          // ' ' +
          // hours +
          // ':' +
          // minutes +
          // ':' +
          // seconds
        );
      }
    },

    onMouseOver() {
      if (this.dialogForm.approvaldate != undefined) {
        this.$refs.iconDate.style.display = "none";
      }
    },
    onMouseleave() {
      this.$refs.iconDate.style.display = "block";
    },

    // 打印
    async printCase(id) {
      this.bid = id;
      await printLvSuoApi({ Id: id }).then((res) => {
        if (res.data.status == "0") {
          if (res.data.data.length > 0) {
            this.lvSuo = res.data.data;
          }
        } else if (res.data.status == "1") {
          this.$message.error(res.data.message);
        } else if (
          res.status == "401" ||
          res.status == "402" ||
          res.status == "403"
        ) {
          this.$message.error(res.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
        } else {
          this.$message.error("未知错误");
        }
      });

      // 判断律所（<代理> 和 <协理> 是否跨所）
      if (this.lvSuo.length > 1) {
        // 跨所，先选选定律所
        this.qrcode = "案件审批单";
        this.lsDialog = true;
      } else {
        // 不跨，查询所需数据
        this.qrcode = "案件审批单";
        this.loading = true;
        await printInfo({
          Id: id,
          OName: null,
          LawyerName: null,
          LawFile: "案件审批单",
          Stype: null,
        }).then(async (res) => {
          this.loading = false;
          if (res.data.status == "0") {
            this.printInfo = res.data.data;
            if (res.data.data.agent == null || res.data.data.agent == "") {
              this.printInfo.agent = res.data.data.client?.[0].pcname;
            }
            if (res.data.data.client != null) {
              if (res.data.data.client.length > 1) {
                this.clientOptions = res.data.data.client;
                this.clientDialog = true;
              } else {
                this.printInfo.client = res.data.data.client?.[0].pcname;
                await this.h2c(id);
              }
            } else {
              await this.h2c(id);
            }
          } else if (res.data.status == "1") {
            this.$message.error(res.data.message);
          } else if (
            res.status == "401" ||
            res.status == "402" ||
            res.status == "403"
          ) {
            this.$message.error(res.message);
            window.sessionStorage.removeItem("token");
            window.sessionStorage.removeItem("hasRoles");
            this.$router.push("/login");
          } else {
            this.$message.error("未知错误");
          }
        });
      }
    },

    async h2c(id) {
      // window.scrollTo(0, 1000)
      await new Promise((resolve) => setTimeout(resolve, 1000)); // 延迟1秒
      var node = document.getElementById("dayin"); //传入的id名称
      // var width = node.offsetWidth //dom宽
      // var height = node.offsetHeight //dom高
      const name = Math.random().toString(36).substring(2);

      await html2canvas(node, {
        backgroundColor: "white", //画出来的图片有白色的边框,不要可设置背景为透明色（null）
        useCORS: true, //支持图片跨域
        scale: 1, //设置放大的倍数
        // height: height,
        // width: width,
        onclone(doc) {
          let e = doc.querySelector("#dayin");
          e.style.display = "block";
        },
      }).then(async (canvas) => {
        // 把生成的base64位图片上传到服务器,生成在线图片地址
        let url = canvas.toDataURL("image/png"); // toDataURL: 图片格式转成 base64
        var blob = this.convertBase64ToBlob(url);
        // console.log(blob)
        // 第一步：将dataUrl转换成Blob
        var fd = new window.FormData();
        // var blob = this.dataURItoBlob(url)
        // console.log('打印flag：' + this.bid)
        fd.append("flag", id);
        fd.append("filetype", "打印");
        fd.append("file", blob);
        fd.append("name", name);
        // 第二步：上传分享图
        axios({
          url: "/api/Filer/PrintUpload",
          method: "post",
          headers: {
            Content: "multipart/form-data",
          },
          data: fd,
        })
          // .post(`'/api/Filer/PrintUpload?flag=${this.bid}'&filetype=${'打印'}`, fd)
          // .post('/api/Filer/PrintUpload', fd)
          .then((res) => {
            // console.log(res)
            if (res.data.status == "0") {
              var id = res.data.data.substring(
                res.data.data.lastIndexOf("=") + 1
              );
              // console.log(id)
              // var code = 'http://localhost:5276/#/print?id=' + id
              var code = "https://glxt.ntlawyer.cc/#/print?id=" + id;
              this.createQrcode(code);
            } else if (
              res.status == "401" ||
              res.status == "402" ||
              res.status == "403"
            ) {
              this.$message.error(res.message);
              window.sessionStorage.removeItem("token");
              window.sessionStorage.removeItem("hasRoles");
              this.$router.push("/login");
            } else {
              this.$message.error("上传错误！: casetext:h2c()");
            }
          })
          .catch(() => {
            this.$message.error("上传错误！");
          });
      });
    },

    //生成二维码方法
    createQrcode(code) {
      // console.log(code)
      let container = document.getElementById("ercode");
      if (container.innerHTML) {
        container.innerHTML = "";
      }
      var qrcode = new QRCode(container, {
        text: code, //这里就是二维码扫描后展示的内容了
        width: 100,
        height: 100,
        colorDark: "black",
        colorLight: "white",
        correctLevel: QRCode.CorrectLevel.L, //二维码的纠错等级，等级越高，二维码呈现越复杂，同时被遮挡的多，也能扫出来
      });
      qrcode.makeCode(code);
      this.daYin(this.printData);
    },

    // 打印方法
    daYin(params) {
      // print.js的onPrintDialogClose事件触发失效,在打印事件触发之前，添加派发一个focus聚焦事件，然后点击取消或打印，清除focus事件。
      let focuser = setInterval(
        () => window.dispatchEvent(new Event("focus")),
        500
      );

      printJS({
        printable: params.printable, // 'casetable', // 标签元素id
        type: params.type || "html",
        header: params.header, // '表单',
        targetStyles: ["*"],
        documentTitle: this.qrcode,
        style: "@page {margin:0 10mm};", // 可选-打印时去掉眉页眉尾
        ignoreElements: params.ignore || [], // ['no-print']
        properties: params.properties || null,
        //打印完成或关闭打印的事件
        onPrintDialogClose: () => {
          //取消打印回调
          //清除focus事件
          clearInterval(focuser);
          // casetable.style.display = 'none'
          this.qrcode = null;
          this.lsDialog = false;
        },
      });
    },

    convertBase64ToBlob(imageEditorBase64) {
      let base64Arr = imageEditorBase64.split(",");
      let imgtype = "";
      let base64String = "";
      if (base64Arr.length > 1) {
        //如果是图片base64，去掉头信息
        base64String = base64Arr[1];
        imgtype = base64Arr[0].substring(
          base64Arr[0].indexOf(":") + 1,
          base64Arr[0].indexOf(";")
        );
      }
      // 将base64解码
      let bytes = atob(base64String);
      //let bytes = base64;
      let bytesCode = new ArrayBuffer(bytes.length);
      // 转换为类型化数组
      let byteArray = new Uint8Array(bytesCode);

      // 将base64转换为ascii码
      for (let i = 0; i < bytes.length; i++) {
        byteArray[i] = bytes.charCodeAt(i);
      }
      // 生成Blob对象（文件对象）
      return new Blob([bytesCode], { type: imgtype });
    },

    // 选择dialog关闭
    lsClose() {
      this.ls = null;
      this.lv = null;
    },

    // 律所改变
    async lvChange() {
      this.lv = null;
      if (this.ls == null || this.ls == "") {
        return;
      }
      await printLvSuoApi({
        Id: this.bid,
        OName: this.ls,
      }).then((res) => {
        if (res.data.status == "0") {
          this.lvShi = res.data.data;
        } else if (res.data.status == "1") {
          this.$message.error(res.data.message);
        } else if (
          res.status == "401" ||
          res.status == "402" ||
          res.status == "403"
        ) {
          this.$message.error(res.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
        } else {
          this.$message.error("未知错误: casetext:lvChange()");
        }
      });
    },

    // 确认打印
    async printEnter() {
      if (this.ls == null || this.ls == "") {
        return this.$message.error("请选择律所!");
      }
      if (this.lv == null || this.lv == "" || this.lv == []) {
        return this.$message.error("请选择律师!");
      }

      this.loading = true;
      await printInfo({
        Id: this.bid,
        OName: this.ls,
        LawyerName: this.lv,
        LawFile: this.lawFile,
        Stype: this.newtype,
      }).then(async (res) => {
        this.loading = false;
        if (res.data.status == "0") {
          this.printInfo = res.data.data;
          if (res.data.data.agent == null || res.data.data.agent == "") {
            this.printInfo.agent = res.data.data.client[0].pcname;
          }
          if (res.data.data.client != null) {
            if (res.data.data.client.length > 1) {
              this.clientOptions = res.data.data.client;
              this.clientDialog = true;
            } else {
              this.printInfo.client = res.data.data.client[0].pcname;
              await this.h2c(this.bid);
            }
          } else {
            await this.h2c(this.bid);
          }
        } else if (res.data.status == "1") {
          this.$message.error(res.data.message);
        } else if (
          res.status == "401" ||
          res.status == "402" ||
          res.status == "403"
        ) {
          this.$message.error(res.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
        } else {
          this.$message.error("未知错误: casetext:printEnter()");
        }
      });
    },

    // 选择代理人打印
    async clientPrint(cp) {
      var newclientOptions = this.clientOptions.filter((item) => {
        return cp.includes(item.pvalue);
      });
      var newclient = [];
      newclientOptions.forEach((v) => {
        newclient.push(v.pcname);
      });
      var newClientstring = newclient.join(",");
      this.printInfo.client = newClientstring;
      this.printInfo.agent = newClientstring;
      this.clientDialog = false;
      await this.h2c(this.bid);
    },
    tableRowClass({ row, rowIndex }) {
      console.log("isoth", row.isOther);
      if (row.isOther) {
        return "beig-row";
      } else {
        return "";
      }
    },
    GetNameIdnumber(data) {
      const filtered = data.flatMap((item) =>
        item.all
          .filter((person) => person.isshow)
          .map((person) => ({
            name: person.name,
            idnumber: person.idnumber,
          }))
      );
    },
    showAllCaseClick() {
      if (this.showAllCase) {
        this.showAllCase = false;
        this.caseConflictData = this.allConflictCase.filter(
          (item) => item.isClient == 1
        ); //所有有冲突的案件
        if (this.caseConflictData.length == 0) {
          //没有冲突案件
          this.caseConflictData.push(this.allConflictCase[0]);
        }
      } else {
        this.caseConflictData = this.allConflictCase;
        this.showAllCase = true;
      }
    },
    //案件冲突
    CaseConflictSelect() {
      this.hasMore = false;
      BKCaseConflict({
        name: this.dialogForm.name,
        idnumber: this.dialogForm.idnumber,
      }).then((res) => {
        if (res.data.status == "success") {
          // 弹出案件冲突
          if (res.data.data.length > 0) {
            this.allConflictCase = res.data.data;

            this.caseConflictData = this.allConflictCase.filter(
              (item) => item.isClient == 1
            ); //所有有冲突的案件
            if (this.caseConflictData.length == 0) {
              //没有冲突案件
              this.caseConflictData.push(this.allConflictCase[0]);
            }
            if (
              this.allConflictCase.length > this.caseConflictData.length &&
              this.allConflictCase.length > 1
            ) {
              this.hasMore = true;
            }
          }
        } else if (
          res.data.status == "401" ||
          res.data.status == "402" ||
          res.data.status == "403"
        ) {
          this.$message.error(res.data.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
          return;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getRandomColor(item, show) {
      if (show) return "#e86e30";
      else if (item) return "blue";
    },
    conflictClick(row) {
      this.chongCaseType = row.typeId.substring(21, 23);
      allCaseApi({
        Id: row.id,
        SelectType: 1, //（0：案件管理，1：案件明细）
      }).then((res) => {
        if (res.data.status == "0") {
          // 案件信息
          this.CTform = res.data.data[0];

          //其他东西
          this.CTform.bcz = JSON.parse(res.data.data[0].bcz);
          for (var i = 0; i < this.CTform.biddingSchemes.length; i++) {
            var name = this.CTform.biddingSchemes[i].name.split(".")[0];
            var type = this.CTform.biddingSchemes[i].name.substring(
              this.CTform.biddingSchemes[i].name.lastIndexOf(".") + 1
            );
          }
          this.isChong = true;
        } else if (
          res.data.status == "401" ||
          res.data.status == "402" ||
          res.data.status == "403"
        ) {
          this.$message.error(res.data.message);
          window.sessionStorage.removeItem("token");
          window.sessionStorage.removeItem("hasRoles");
          this.$router.push("/login");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    closChong() {
      this.isChong = false;
    },
    // 必选标识
    addRedStar(h, { column }) {
      return [
        h("span", { style: "color: #F56C6C" }, "*"),
        h("span", " " + column.label),
      ];
    },
    // 案件当事人背景颜色
    tableRowClassName({ row, rowIndex }) {
      // console.log(row.isClient)
      if (row.isClient || row.isClient) {
        return "isclient-row";
      } else {
        return "";
      }
    },
    //关闭弹出框按钮
    handleClose() {
      this.detailsDialog = false;
      this.$refs["dialogForm"].resetFields();
      this.dialogForm = {
        id: null,
        name: null,
        leadLawyer: null,
        coCounsel: null,
        soure: null,
        approvaldate: null,
        caseLeaders: null,
        level: null,
        sealtype: null,
        status: null,
        code: null,
        idnumber: null,
        sealtype: null,
      };
      this.caseConflictData = [];
    },

    chanle() {
      this.conflictList = [];
      this.caseConflict = false; // 冲 突
      this.dialogshowAllCase = false;
      this.dialoghasMore = false;
      this.formConflict.conflictApproval = null;
      this.edit=false
    },

     async getLink() {
      // var row = this.$route.query

      var row = this.getUrlParams(window.location.href)
      // console.log('all-row', row)
      if (row !== undefined && row != null && JSON.stringify(row) !== '{}') {  
         await this.selectCase(row.id)
      }
    },
    getUrlParams(url) {
      const params = {}
      const regex = /[?&]+([^=&]+)=([^&]*)/g
      let match

      while ((match = regex.exec(url))) {
        const key = decodeURIComponent(match[1])
        const value = decodeURIComponent(match[2])
        params[key] = value
      }

      if (params == {}) {
        return null
      } else {
        return params
      }
    },
  },

  created() {
    this.GetLawyer();
    this.inputCase();
    this.getLink()
  },

  watch: {
    "dialogForm.leadLawyer": {
      handler(newValue, oldValue) {
        this.LeadLawyerChange(this.dialogForm.leadLawyer);
      },
      deep: true,
    },

    
  },
};
</script>

<style lang="less" scoped>
.bankruptcy {
  .select {
    width: 10vw;
    margin-right: 10px;
  }
  .selectName {
    width: 99vw;
    margin-right: 10px;
  }
  .date_box {
    .el-icon-date {
      position: absolute;
      top: 50%;
      right: 10px;
      z-index: 9;
      color: #c0c4cc;
      font-size: 14px;
      transform: translateY(-50%);
    }

    /deep/ .el-range__close-icon {
      position: absolute;
      right: 34px;
      top: 54%;
      transform: translateY(-50%);
    }
  }

  .casestatus {
    color: #2bc887;
  }

  .casesresult {
    color: #fe964a;
  }

  .casesrefuse {
    color: #df0d0d;
  }

  .pagination {
    // margin-top: 18px;
    margin: 20px 0px 20px 0px;
    width: 100%;
    overflow: hidden;
    text-align: right;
  }

  .right {
    width: 80%;
    margin: auto;
    margin-top: 3.125rem;
    text-align: left;
  }

  /* ::v-deep穿透 改变element ui组件样式 */
  ::v-deep .pagination .el-pagination__total {
    float: left;
  }

  ::v-deep .pagination .el-pagination__sizes {
    float: left;
  }

 // 打印
.dayin {
  width: 557px;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  font-family: '宋体';
  display: none;
  // display: flex;

  .chenghu {
    text-decoration: underline;
    display: inline-block;
    min-width: 300px;
  }
  #casetable {
    width: 557px;
    margin: 0 auto;
    font-family: '宋体';
    line-height:14px;
  }

  #casetable .center_font {
    text-align: center;
  }

  #casetable .case_title {
    font-size: 18px;
    font-weight: bold;
  }

  .case_code {
    font-size: 14px;
  }

  .input_con {
    border-bottom: 1px solid #333;
    width: 180px;
    display: inline-block;
  }

  .input_shortcon {
    border-bottom: 1px solid #333;
    width: 10%;
    display: inline-block;
  }

  .case_span_border {
    border-bottom: 1px solid #333;
  }

  .case_row {
    height: 40px;
  }

  .text-right {
    text-align: right;
  }

  .text_space {
    text-indent: 2em;
  }

  .text_center {
    text-align: center;
  }

  .qrcode {
    /*二维码*/
    margin-left: 14px;
  }

  .case_tb {
    width: 100%;
    height: 700px; /*overflow:hidden;*/
  }

  table tr .td_l {
    width: 30%;
    font-size: 16.5px;
    font-weight: bold;
    text-align: center;
    line-height: 22px;
  }

  table tr .td_r {
    width: 70%;
    font-size: 15px !important;
    text-align: center;
    line-height: 22px;
  }

  .td_gy {
    height: 80px;
  }

  .td_hhr {
    height: 70px;
  }

  table tr td label {
    float: left;
    line-height: 30px;
    width: 32%;
  }

  table tr td label input {
    vertical-align: middle;
    height: 18px;
    width: 19px;
  }

  table tr td label span {
    vertical-align: middle;
    color: #333;
    font-weight: 100;
  }

  .td_rs {
    padding: 0 20px;
  }

  table tr td p {
    width: 100%;
    line-height: 22px;
    font-size: 12.5px;
    padding: 0 2%;
    margin-bottom: 5px;
    color: #666;
    float: left;
    text-align: left;
  }

  table tr td p .case_span_border {
    min-width: 50%;
  }

  #Print_btn {
    float: right;
    margin-bottom: 25px;
    line-height: 25px;
    margin-left: 15px;
  }

  #FenSuoChange {
    float: right;
    margin-bottom: 25px;
    height: 31px;
  }

  .AdmissibleInstitution_span {
    display: inline-block;
    min-width: 45%;
    line-height: 20px;
    margin-left: 40px;
  }

  .td_zhu {
    font-size: 9px;
  }

  .td_p_date {
    width: 40%;
    float: right;
    font-size: 15px;
    text-align: right;
  }

  table tr .td_gaiyao {
    text-align: left;
    text-indent: 40px;
  }

  table tr .td_time {
    text-align: right;
  }

  .minwidth {
    min-width: 0;
  }

  .han_margintop {
    margin-top: 30px;
  }
}
}

// 案件冲突
.conflict {
  width: 98%;
  margin: 12px auto;
  border-radius: 16px;
}

::v-deep .el-table--border th.el-table__cell,
::v-deep .el-table td.el-table__cell {
  border-bottom: none !important;
}

::v-deep .el-table--border .el-table__cell {
  border-right: none !important;
}

::v-deep .el-table td.el-table_cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 0px solid #ebeef5 !important;
}
/deep/.beig-row {
  background: #e6e5e4 !important;
}
.top {
  width: 100%;
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 1.1875rem;
  font-weight: 400;
  padding-left: 3.625rem;
  margin-bottom: 2rem;
}

.icon {
  width: 0.25rem;
  height: 1.125rem;
  background: #3077e6;
  border-radius: 0.5625rem;
  margin-right: 0.3125rem;
}
.copy {
  color: #3077e6;
  border: none;
}
// 表格
.party {
  width: 100%;
  margin: auto;
  ::v-deep .isclient-row {
    background: #fff1dc;
  }

  ::v-deep .el-table__body tr:hover > td {
    background-color: transparent !important;
  }
  // /deep/.el-input.is-disabled .el-input__inner {
  //   background-color: #ffffff;
  //   border-color: #e4e7ed;
  //   color: #000;
  //   cursor: not-allowed;
  // }
}

.party ::v-deep .el-input__inner {
  border: none;
}

//表格
.bankruptcy::v-deep .el-table th.el-table__cell {
  overflow: hidden;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  background-color: #fafafa;
}

.party {
  margin-bottom: 55px;
  margin-left: 5%;

  ::v-deep .el-input__inner {
    border: none;
    padding-left: 0;
    // height: 24px;
    // line-height: 24px;
    text-align: center;
  }

  ::v-deep .el-input--prefix .el-input__inner {
    padding-left: 0px;
  }
}

// /deep/ .el-table tbody tr:hover>td {
//   background-color: #fff !important;
// }

::v-deep tbody tr:hover > td {
  background-color: #fff;
}

/deep/ .el-table th {
  //标题背景色
  background-color: #fafafa;
}

.copy {
  color: #3077e6;
  cursor: pointer;
}

.text {
  display: flex;
  color: #3077e6;
  align-items: center;
  font-size: 1.1875rem;
  font-weight: 400;
  padding-left: 3.625rem;
  margin-bottom: 2rem;
}
</style>